import { type VoceGuidaCompilazioneRequestTesto } from '@framework/api-client/api/inquiries/schemas/voceGuidaCompilazioneRequestTesto.ts';
import { StyledRteHtmlTextGuide } from '@framework/engine/inputs/rich-text/style/StyledRteHtmlTextGuide.tsx';
import { renderRichTextAdvancedNodes } from '@framework/engine/inputs/rich-text-advanced/render/renderRichTextAdvancedNodes.tsx';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import styled from 'styled-components';

const GuideTextDiv = styled.div`
  &&& {
    ${StyledRteHtmlTextGuide}
  }
`;

export interface IGuideTextStyledProps {
  text?: VoceGuidaCompilazioneRequestTesto[] | null;
}

/**
 * Una singola voce di guida
 */
export function GuideTextStyled(props: IGuideTextStyledProps) {
  const renderedTexts = useMemo(
    () =>
      props.text?.map(element => renderRichTextAdvancedNodes(element?.text)),
    [props.text],
  );

  if (!props.text || !renderedTexts || isEmpty(props.text)) return null;

  return (
    <GuideTextDiv>
      {renderedTexts.map((renderedText, i) => (
        <span key={i}>{renderedText}</span>
      ))}
    </GuideTextDiv>
  );
}
